exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2lqu2jbcl1T6W0UIWiqiRB{font-size:15px;line-height:22px;width:202px;display:flex}._2lqu2jbcl1T6W0UIWiqiRB ._2l6rj91Rzg1iXpFu-Lk1um{margin-right:15px;line-height:0}._2lqu2jbcl1T6W0UIWiqiRB ._2l6rj91Rzg1iXpFu-Lk1um img{height:50px;width:50px;border-radius:50%;box-shadow:1px 1px 4px 0 rgba(0,0,0,0.1)}._2lqu2jbcl1T6W0UIWiqiRB .XtOEaYcg4zlPk2LdUD-cN{font-weight:500;color:#424242;font-size:14px}._2lqu2jbcl1T6W0UIWiqiRB ._129g5q2gvPamnJCZEoaKsA{color:#757575;font-size:14px}._2lqu2jbcl1T6W0UIWiqiRB ._2aN5xvMdmyEP_LcriPey8W{color:#757575;font-size:12px}\n", ""]);

// Exports
exports.locals = {
	"UserPopup": "_2lqu2jbcl1T6W0UIWiqiRB",
	"profileImg": "_2l6rj91Rzg1iXpFu-Lk1um",
	"username": "XtOEaYcg4zlPk2LdUD-cN",
	"meta": "_129g5q2gvPamnJCZEoaKsA",
	"latlng": "_2aN5xvMdmyEP_LcriPey8W"
};